import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { createGrid as createGridMutation } from "@/graphql/mutations";
import { GraphQLError } from "graphql";
import type { Grid } from "@/API";
import { addGridInGrids } from "./getGridsState";
import { getRestaurantsInGrid } from "@/graphql/queries";

const client = generateClient();

export const duplicateGridState = create<State<Grid | null>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const duplicateGridIsloading = () =>
  duplicateGridState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const duplicateGridIsError = (error: GraphQLError[] | undefined) =>
  duplicateGridState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const duplicateGridIsSuccess = (queryResult: Grid) =>
  duplicateGridState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetduplicateGridState = () =>
  duplicateGridState.setState(() => duplicateGridState.getInitialState());

type duplicateGridParams = {
  grid: Grid;
};

export const duplicateGrid = async (params: duplicateGridParams) => {
  duplicateGridIsloading();
  const { grid } = params;

  try {
    const { data: getRestaurantsInGridQuery } = await client.graphql({
      query: getRestaurantsInGrid,
      variables: {
        gridId: grid.id,
      },
    });

    if (getRestaurantsInGridQuery.getRestaurantsInGrid) {
      const restaurantIds = getRestaurantsInGridQuery.getRestaurantsInGrid.data
        .filter((restaurant) => restaurant !== null)
        .map((restaurant) => restaurant.id);

      const { data: createGridMutationData } = await client.graphql({
        query: createGridMutation,
        variables: {
          restaurantIds: restaurantIds,
          name: grid.name,
          columns: grid.columns,
        },
      });

      duplicateGridIsSuccess(createGridMutationData.createGrid);
      addGridInGrids(createGridMutationData.createGrid);
    }
  } catch (e) {
    const graphQl = e as GraphQLResult<Grid>;
    duplicateGridIsError(graphQl.errors);
  }
};
